import '@/styles/register-toast.css';
import { useEffect } from 'react';

export type RegisterToastType = 'info' | 'success' | 'error';

interface RegisterToastProps {
  message: string | null;
  type?: RegisterToastType;
  onClose: () => void;
}

export function RegisterToast({ message, type = 'info', onClose }: RegisterToastProps) {
  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(onClose, 5000);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  const borderClass =
    type === 'error' ? 'register-toast--error' : type === 'success' ? 'register-toast--success' : '';

  return (
    <div id="register-notification" className="register-toast">
      <div className={`register-toast-inner ${borderClass}`}>
        <div className="register-toast-row">
          <span id="register-notification-content" className="register-toast-content">
            {message}
          </span>
          <button
            type="button"
            id="register-notification-close"
            className="register-toast-close"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
      </div>
    </div>
  );
}
